export class Config {

    static urlserveur = 'https://api.bessalel.net';
    // static urlserveur = 'http://127.0.0.1:8000';
    static apiUrl= Config.urlserveur + '/api/';
    static urlmediatheque = '/bundles/sadevdefault/vendors/mediatheque/index.php';
    //static apiUrl= 'https://app.mulatocud.org/api/';
    static ckeditorconfig = {
            filebrowserBrowseUrl: Config.urlserveur + Config.urlmediatheque + '?mime=all',
            filebrowserImageBrowseUrl: Config.urlserveur + Config.urlmediatheque + '?mime=image',
            removeDialogTabs: 'link:upload;image:upload'
        }


 }